import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const companyMechanic = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/mechanics',

        branches: [],
        branchesLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        branches: state => state.branches
    },
};
